module.exports = __webpack_public_path__ + "img/lp-Chest.5ac6e577.png";